import isMedicoExterno from './medicoHelpers';
import isAdminFuncionario from './isAdminFuncionario';

/**
 * Menu e rotas de Administração: médicos do ICM (não externos) ou
 * funcionários com WEB_ACESSO admin (TOTAL, TOTAL2, ADM).
 */
export default function canAccessAdministracao(medico, funcionario) {
  if (medico && !isMedicoExterno(medico)) {
    return true;
  }
  return isAdminFuncionario(funcionario);
}
